import { Role } from './role';
import { z } from 'zod';

export type ManagerLink = z.infer<typeof ManagerLink>;
export type RoleLink = z.infer<typeof RoleLink>;
export type EntitlementLink = z.infer<typeof EntitlementLink>;

export const ManagerLink = z.object({
    relation: z.enum(['manager', 'additionalApprover', 'substitute']),
    ofUserId: z.string(),
    ofUserName: z.string(),
});

export const RoleLink = z.object({
    relation: z.literal('role'),
    role: Role,
});

export const EntitlementLink = z.union([ManagerLink, RoleLink]);
